import { render } from "./Summary.vue?vue&type=template&id=680f1f7e&scoped=true"
import script from "./Summary.vue?vue&type=script&lang=js"
export * from "./Summary.vue?vue&type=script&lang=js"

import "./Summary.vue?vue&type=style&index=0&id=680f1f7e&lang=scss&scoped=true"
import "./Summary.vue?vue&type=style&index=1&id=680f1f7e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680f1f7e"]])

export default __exports__